<template>
  <div
    id="pdfCompany"
    class="p-4 w-full"
    style="color: #fff; background-color: #080718ff; border: 1px solid #171325ff"
  >
    <div class="w-full flex">
      <div class="flex-1"></div>
      <div class="cursor-pointer" @click="cancel">
        <close-outlined class="clsIco" style="font-size: 20px" />
      </div>
    </div>

    <div class="text-center w-full" style="font-size: 18px">
      {{ getTranslation(reportInfo.factoryName) }} -
      {{ getTranslation(reportInfo.groupName) }} -
      {{ getTranslation(reportInfo.machineName) }} - {{ langObj["诊断报告"] }}
    </div>

    <div class="w-full flex items-center">
      <div class="text-center flex-1" style="font-size: 16px">
        {{ langObj["报告时间"] }}: {{ reportInfo.date }}
      </div>
      <div>
        <button @click="handleDown()" nz-button nzType="text" class="ml-2">
          <download-outlined style="font-size: 18px" />
        </button>
      </div>
    </div>

    <div class="mt-2">
      <div>1.{{ langObj["设备信息"] }}</div>
      <div>
        {{ langObj["诊断设备"] }}:
        {{ getTranslation(reportInfo.factoryName) }} /
        {{ getTranslation(reportInfo.groupName) }} /
        {{ getTranslation(reportInfo.machineName) }} / {{ langObj["诊断报告"] }}
      </div>
    </div>

    <div class="mt-2">
      <div>2.{{ langObj["设备健康状态"] }}</div>
      <div v-if="reportInfo.expertReport" class="flex items-center">
        <div
          class="mr-1"
          style="width: 10px; height: 10px; border-radius: 50%"
          :style="{
            background: gradeList.find(
              (p) => p.value === reportInfo.expertReport.grade
            )?.color,
          }"
        ></div>
        <span>{{
          langObj[
            gradeList.find((p) => p.value === reportInfo.expertReport.grade)
              ?.label
          ]
        }}</span>
        <span>：</span>
        <span>{{
          langObj[
            gradeList.find((p) => p.value === reportInfo.expertReport.grade)
              ?.dec
          ]
        }}</span>
      </div>
    </div>

    <div class="mt-2">
      <div>3.{{ langObj["诊断结果"] }}</div>
      <div class="mt-2 w-full" style="border: 1px solid #465488">
        <div class="w-full flex items-center p-2">
          <div style="width: 15%" class="px-2">{{ langObj["故障模式"] }}</div>
          <div style="width: 35%" class="px-2">{{ langObj["诊断结论"] }}</div>
          <div style="width: 25%" class="px-2">{{ langObj["故障原因"] }}</div>
          <div style="width: 25%" class="px-2">{{ langObj["建议及措施"] }}</div>
        </div>
        <div
          v-if="
            reportInfo.expertReport && reportInfo.expertReport.diagnosisDetails
          "
        >
          <div
            style="border-top: 1px solid #465488"
            v-for="(item, index) in reportInfo.expertReport.diagnosisDetails"
            :key="index"
            class="w-full flex items-center p-2"
          >
            <div style="width: 15%" class="px-2">
              {{ langObj[item.faultEvent] || item.faultEvent }}
            </div>
            <div style="width: 35%" class="px-2">
              {{ getDiagLang(item.diagnoseMessage) }}
            </div>
            <div style="width: 25%" class="px-2">
              <div v-for="(cause, i) in item.faultCauses" :key="i">
                {{ getLanguage(cause) }}
              </div>
            </div>
            <div style="width: 25%" class="px-2">
              <div v-for="(suggest, i) in item.faultSuggests" :key="i">
                {{ getLanguage(suggest) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="mt-2 w-full"
      v-if="reportInfo.expertReport && reportInfo.expertReport.diagnosisDetails"
    >
      <div
        v-for="(item, index) in reportInfo.expertReport.diagnosisDetails"
        :key="index"
      >
        <div v-for="(t, i) in item.trends" :key="i">
          <div
            :id="'chart' + index + i"
            style="margin-top: 10px; width: 100%; height: 200px"
          ></div>
        </div>
      </div>
    </div>

    <div
      class="mt-2 w-full"
      v-if="reportInfo.pictures && reportInfo.pictures.length"
    >
      <div>4.{{ langObj["图片"] }}</div>
      <div class="w-full">
        <div
          style="width: 50%"
          v-for="(item, index) in reportInfo.pictures"
          :key="index"
        >
          <div class="w-full text-center">{{ item.remark }}</div>
          <a-image class="w-full" :src="item.url" :alt="item.remark" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import request from "../../../common/request";
import { ref, reactive, toRaw } from "vue";
import { v4 as uuidv4 } from "uuid";
import { getGroupName, getFactoryName } from "../../../common/tools";
import * as echarts from "echarts";
import { langList } from "../../../common/lang";
import htmlToPdf from "../../../common/htmlToPdf";
import { message } from "ant-design-vue";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate";

let reportInfo: any = ref({});
let langObj: any = ref({});
let language: any = ref("English");
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
  langObj.value = langList[language.value];
};
getLang();

let getDiagLang = (diagnosticNotes:any) => {
    try{
        let list1 = diagnosticNotes.split("；").filter((p:any) => p)
        let content = ''
        list1.map((d:any) => {
            let s1 = d.split("存在异常特征，判断为");
            let s1_1 = getTranslation(s1[0]);
            let s2 = s1[1].split('，');
            let s2_1 = getLanguage(s2[0]);

            let s3 = ''
            if(s2.length === 3) {
                s3 = '，' + s2[1] + '，' + s2[2]
            } else {
                s3 = '，' + s2[1]
            }
            if(language.value === 'English') {
                s3 = s3.replace("无设备故障，可持续运行", "there is no equipment failure and it can operate continuously")
                s3 = s3.replace("请关注设备分数变化情况", "please pay attention to the changes in the device scores")
                s3 = s3.replace("请关注设备状态与分数变化情况", "please pay attention to the status of the equipment and the changes in scores")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查", "please pay close attention to the status of the equipment and the changes in scores, and arrange inspections in a timely manner based on the on-site situation")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检修", "please pay close attention to the status of the equipment and the changes in the score, and arrange maintenance in a timely manner in combination with the on-site situation")
                s3 = s3.replace("建议停机维护", "it is suggested to shut down for maintenance")
            }

            content = content + s1_1 + getLanguage("存在异常特征，判断为")+ s2_1 + s3
        })
        return content
    } catch(err:any) {
        return diagnosticNotes
    }
    
};

let gradeList = [
  { value: -1, label: "健康", color: "#61c08f", dec: "无需操作" },
  {
    value: 0,
    label: "可用",
    color: "#706a00ff",
    dec: "发现异常特征，按照巡查计划现场查看设备状态",
  },
  {
    value: 1,
    label: "警戒",
    color: "#cd5f3b",
    dec: "发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备",
  },
  {
    value: 2,
    label: "故障",
    color: "#921e37",
    dec: "设备故障严重，建议停机维修",
  },
];

const show = async (id: any) => {
  let config: any = {
    params: {
      id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/reports/info", config);

  if (result && result.data) {
    reportInfo.value = result.data;

    if (reportInfo.value.machines && reportInfo.value.machines.length) {
      reportInfo.value.factoryName = getFactoryName(
        reportInfo.value.machines[0].factoryId
      );
      reportInfo.value.groupName = getGroupName(
        reportInfo.value.machines[0].groupId
      );
      reportInfo.value.machineName = reportInfo.value.machines[0].machineName;

      reportInfo.value.expertReport?.diagnosisDetails &&
        reportInfo.value.expertReport.diagnosisDetails.map((d: any) => {
          d.faultCause = getLanguage(d.faultCause);
          d.faultCauses = d.faultCause
            ? d.faultCause.replace("\r\n", "\n").split("\n")
            : [];

          d.faultSuggest = getLanguage(d.faultSuggest);
          d.faultSuggests = d.faultSuggest
            ? d.faultSuggest.replace("\r\n", "\n").split("\n")
            : [];
        });

      setTimeout(() => {
        reportInfo.value.expertReport &&
          reportInfo.value.expertReport.diagnosisDetails.map(
            (d: any, index: any) => {
              d.trends &&
                d.trends.map((item: any, i: any) => {
                  initChart(item, "chart" + index + i);
                });
            }
          );
      }, 1000);
    }
  }
};

const initChart = (data: any, id: any) => {
  let dataAll: any = [];
  data.date.map((d: any, i: any) => {
    dataAll.push({ date: d, value: data.value[i] });
  });

  dataAll.sort(function (a: any, b: any) {
    if (a.date < b.date) return -1;
    if (a.date > b.date) return 1;
    return 0;
  });

  let dates = dataAll.map((p: any) => p.date);
  let values = dataAll.map((p: any) => p.value);
  data.date = dates;
  data.value = values;

  const ec = echarts as any;
  let doc = document.getElementById(id);
  if (!doc) return; // initChart放在timeout里面，可能会出现doc为null的情况
  let myChart = ec.init(doc);

  let markList: any[] = [];

  data.markLine?.data?.forEach((d: any) => {
    if (d.name == "开") {
      markList.push({
        name: langObj.value["开"],
        xAxis: d.xAxis,
        label: { show: true, color: "#fff", formatter: "{b}" },
        lineStyle: { color: "green" },
      });
    }
    if (d.name == "关") {
      markList.push({
        name: langObj.value["关"],
        xAxis: d.xAxis,
        label: { show: true, color: "#fff", formatter: "{b}" },
        lineStyle: { color: "rgb(173, 38, 64)" },
      });
    }
  });

  // console.log(markList)

  let titleT = ref("");
  if (!data.title) {
    data.title = "";
  }
  if (data.title.indexOf(":") != -1) {
    let titleArr = data.title.split(":");
    let title1 = langObj.value[titleArr[0]] || titleArr[0];
    let title2 = langObj.value[titleArr[1]] || titleArr[1];
    titleT.value = title1 + ":" + title2;
  } else if (data.title.indexOf("：") != -1) {
    let titleArr = data.title.split("：");
    let title1 = langObj.value[titleArr[0]] || titleArr[0];
    let title2 = langObj.value[titleArr[1]] || titleArr[1];
    titleT.value = title1 + ":" + title2;
  }

  const option = {
    title: {
      left: "center",
      textStyle: {
        fontSize: 12,
        color: "#fff",
      },
      text: titleT.value,
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: "20%",
      left: "6%",
      right: "6%",
      bottom: "6%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: data.date,
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        type: "line",
        data: data.value,
        markLine: {
          data: markList,
          silent: true,
        },
      },
    ],
  };
  myChart.setOption(option);
};

const cancel = () => {
  emits("cancel", true);
};

const emits = defineEmits(["cancel"]);

defineExpose({
  show,
});
const resultReport = ref<any>({});

// 下载pdf
let loadingDown = ref(false);
const handleDown = async () => {
  loadingDown.value = true; // 动画加载事件
  // 调用htmlToPdf工具函数
  let result = await htmlToPdf.getPdf("诊断报告", "a4");
  loadingDown.value = false;
  if (result) {
    message.success("下载成功");
  } else {
    message.warning("下载失败，请重试");
  }
};

// 转繁体
const translateFt = (ev: any) => {
  let content: any = ev;
  if (ev && language.value === "Chinese_ft") {
    content = getChineseFt(ev);
  }
  return content;
};
</script>
<style lang="less" scoped>
.box {
  border: 1px solid #171325ff;
  background: #171325ff;
}

.fff {
  color: #fff;
}

/deep/ .ant-table {
  background: #080718ff;
  color: #fff;
}

/deep/ .ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: transparent;
}

/deep/ .ant-empty-normal {
  color: #fff;
}

/deep/ .ant-descriptions-item-content {
  color: #fff;
}

/deep/ .ant-table-tbody > tr > td {
  border-bottom: 0px solid #fff;
}

/deep/ .ant-select-clear span {
  background-color: #000;
}

/deep/ .ant-upload.ant-upload-select-picture-card {
  background: #021766;
}

.clsIco {
  svg {
    color: #fff !important;
  }
}
</style>
